import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_FINANCIALS_START,
} from '../../actions/types'

import {
  updateFinancialsSuccess,
  updateFinancialsFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'

import {
  getLoanApplicationId,
} from '../../reducers'

function* loanUpdateFianancials(action) {
  const loanApplicationId = yield select(getLoanApplicationId);

  const data = {
    loan_application_user: {
      credit_sense_report_attributes: {
        enabled: action.payload.creditSenseTerminated
      }
    }
  }

  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateFinancialsSuccess(response))
  } else {
    yield put(updateFinancialsFailure({
      errors: error.response.data.errors,
    }))
  }
}

export function* watchLoanUpdateFinancials() {
  yield takeLatest(UPDATE_FINANCIALS_START, loanUpdateFianancials)
}
